import { render, staticRenderFns } from "./CookieLayer.vue?vue&type=template&id=023a6b24"
import script from "./CookieLayer.vue?vue&type=script&lang=ts"
export * from "./CookieLayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports